import styled, {css} from 'styled-components';
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const GameViewSectionCSS = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 2px;
    justify-content: center;
`;

const MiddleSeparatorWrapperGameViewSectionPCBox = styled.div`
    ${GameViewSectionCSS}
     margin: 0 30px;
`;

const MiddleSeparatorWrapperGameViewSectionMobileBox = styled.div`
    ${GameViewSectionCSS}
     margin: 0 10px;
`;

export const MiddleSeparatorWrapperGameViewSectionBox = styledByDevice(MiddleSeparatorWrapperGameViewSectionPCBox, MiddleSeparatorWrapperGameViewSectionMobileBox);

export const GameWrapperGameViewSectionBox = styled.div`
    ${GameViewSectionCSS}
     margin-left: 0;
`;

export const ButtonWrapperGameViewSectionBox = styled.div`
    ${GameViewSectionCSS}
     margin-right: 0;
     flex-shrink: 0;
`;
